var b = Object.defineProperty;
var d = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var c = (a, e, t) => e in a ? b(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t, s = (a, e) => {
  for (var t in e || (e = {}))
    u.call(e, t) && c(a, t, e[t]);
  if (d)
    for (var t of d(e))
      g.call(e, t) && c(a, t, e[t]);
  return a;
};
var o = (a, e) => {
  var t = {};
  for (var r in a)
    u.call(a, r) && e.indexOf(r) < 0 && (t[r] = a[r]);
  if (a != null && d)
    for (var r of d(a))
      e.indexOf(r) < 0 && g.call(a, r) && (t[r] = a[r]);
  return t;
};
import { jsx as l } from "react/jsx-runtime";
import { c as n } from "./clsx-0d472180.js";
function x(a) {
  const e = o(a, []);
  return e.className = n("overflow-x-auto", e.className), /* @__PURE__ */ l("div", s({}, e));
}
function i(a) {
  const e = o(a, []);
  return e.className = n(
    "w-full text-sm text-left text-gray-500 dark:text-gray-400 rounded",
    e.className
  ), /* @__PURE__ */ l("table", s({}, e));
}
function y(a) {
  const e = o(a, []);
  return e.className = n(
    "text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 font-bold rounded-t align-top",
    e.className
  ), /* @__PURE__ */ l("thead", s({}, e));
}
function N(a) {
  const e = o(a, []);
  return /* @__PURE__ */ l("tbody", s({}, e));
}
function T(a) {
  const e = o(a, []);
  return /* @__PURE__ */ l("tfoot", s({}, e));
}
function P(a) {
  const e = o(a, []);
  return e.className = n(
    "border-b dark:border-gray-700",
    e.className
  ), /* @__PURE__ */ l("tr", s({}, e));
}
function k(a) {
  const e = o(a, []);
  return e.className = n("px-4 py-3", e.className), /* @__PURE__ */ l("td", s({}, e));
}
export {
  x as T,
  i as a,
  y as b,
  N as c,
  T as d,
  P as e,
  k as f
};
